import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function TermsPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-6 pb-12">
        <div className="w-full px-4 md:px-6 lg:px-8 max-w-3xl mx-auto">
          <nav className="text-sm text-stone-500 mb-6">
            <a href="/" className="hover:text-emerald-700 transition-colors">{t('breadcrumb_home')}</a>
            <span className="mx-2">/</span>
            <span className="text-stone-700">Terms</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-bold text-stone-800 mb-6">Terms of Service</h1>

          <div className="space-y-6">
            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Acceptance of Terms</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                By accessing and using this website, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use this website. These terms apply to all visitors, users, and others who access or use the website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Use of Content</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                All content on this website is provided for informational purposes only. You may view, download, and print content for personal, non-commercial use only. You may not modify, reproduce, distribute, or create derivative works from any content without prior written permission.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">External Links</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                This website contains links to third-party websites. These links are provided for your convenience and information. We do not endorse or control these third-party sites, and we are not responsible for their content, accuracy, or practices. Use external links at your own risk.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Limitation of Liability</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                CSSBuyBR and its content are provided "as is" without any warranties. We do not guarantee the accuracy, completeness, or reliability of any information on this website. We are not liable for any losses, damages, or expenses arising from the use of this website or reliance on any information contained herein.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Intellectual Property</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                All content, trademarks, logos, and other intellectual property displayed on this website are owned by CSSBuyBR or used with permission. Unauthorized use of any content may violate copyright, trademark, and other laws.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Changes to Terms</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Your continued use of the website after any changes constitutes acceptance of the revised terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Governing Law</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                These terms shall be governed by and construed in accordance with applicable laws. Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the courts in the relevant jurisdiction.
              </p>
            </section>
          </div>

          <p className="mt-8 text-xs text-stone-400">Last updated: August 27, 2026</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}